import { useLazyQuery as m } from "@apollo/client";
import { CurrencyTokenType as e } from "../../constants/currency.js";
import { onChainTokenToUsdSchema as u } from "../../deserialize/yup/currency.js";
import p from "../../graphql/query/getTokenPriceToUSD.js";
import { deserializeListData as l } from "../../../temp-lib/graphql/deserialize/index.js";
import { useState as d, useCallback as f } from "react";
const T = [
  e.Anima,
  e.Aprs,
  e.Weth,
  e.Usdc,
  e.WRon,
  e.Ron
], C = () => {
  const t = Object.values(T), [o, { loading: a }] = m(p, {
    variables: { currencies: t }
  }), [s, n] = d([]), c = f(async () => {
    const { data: i } = await o({ variables: { currencies: t } }), r = l(
      { data: i },
      u
    );
    return n(r), r;
  }, [t, o]);
  return {
    data: s,
    loading: a,
    fetch: c
  };
};
export {
  C as default
};
//# sourceMappingURL=useGetTokenPriceToUSD.js.map
